function createKey(e: any) {
  return `${e.audience}::${e.scope}`;
}

function getExpirationTimeoutInMilliseconds(expiresIn: number, exp: number) {
  const expTime =
    (new Date(exp * 1000).getTime() - new Date().getTime()) / 1000;
  return Math.min(expiresIn, expTime) * 1000 * 0.8;
}

export class Cache {
  private cache: Record<string, any> = {};

  save(entry: any) {
    const key = createKey(entry);
    this.cache[key] = entry;

    const expiresIn = Number(entry?.expires_in);
    const exp = Number(entry?.decodedIdToken?.claims?.exp);
    if (!Number.isFinite(expiresIn) || !Number.isFinite(exp)) {
      return;
    }

    const timeout = getExpirationTimeoutInMilliseconds(
      expiresIn,
      exp
    );

    if (timeout <= 0) {
      delete this.cache[key];
      return;
    }

    setTimeout(() => {
      delete this.cache[key];
    }, timeout);
  }

  get(entry: any) {
    return this.cache[createKey(entry)];
  }
}
